exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tbody tr td .center{\r\n    text-align: center !important;\r\n}\r\n\r\n.cenbter{\r\n    text-align: center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/agendamiento-app/agendamiento-app.component.css
// module id = ../../../../../src/app/main/agendamiento-app/agendamiento-app.component.css
// module chunks = main